import { Availability } from './LicenseAvailability';

interface Props {
  availability: Availability;
  /** `md` for the license-type header (h-2), `sm` for a term row (h-1.5). */
  size: 'sm' | 'md';
}

/**
 * The thin availability progress bar shared by the license-type header and
 * the individual term rows. Flat gray when nothing is available or the set is
 * over-activated; otherwise filled to `percentAvailable`, red when low.
 */
function AvailabilityBar({ availability, size }: Props) {
  const { available, isOverActivated, isLow, percentAvailable } = availability;
  const height = size === 'md' ? 'h-2' : 'h-1.5';

  if (isOverActivated || available === 0) {
    return <div className={`w-full ${height} bg-muted rounded-full`} />;
  }

  return (
    <div className={`w-full ${height} bg-muted rounded-full overflow-hidden`}>
      <div
        className={`h-full transition-all ${isLow ? 'bg-destructive' : 'bg-accent'}`}
        style={{ width: `${percentAvailable}%` }}
      />
    </div>
  );
}

export default AvailabilityBar;
